import Pages from '@opsbase/lib-pages';
import i18n from '@opsbase/lib-i18n';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import DVLPage from '@opsbase/web-dvl-page';
import Vertical from '@opsbase/web-layout/Vertical';
import useParams from '@opsbase/web-nav/useParams';
import React from 'react';
import IssueMenu from '../../menus/IssueMenu';
import IssuesSelectionToolbar from '../../toolbars/IssuesSelectionToolbar';
export function IssuesAnalyseDialog() {
    let { viewId } = useParams();
    return (React.createElement(Dialog, { size: DialogSize.XFULL_YFULL },
        React.createElement(Vertical, { style: { overflow: 'hidden' } },
            React.createElement(DVLPage, { key: "issueslog", viewId: viewId, itemPage: Pages.ISSUES_VIEW, itemMenu: IssueMenu, notFoundText: i18n.t('no-issues-found'), itemSelectionToolbar: React.createElement(IssuesSelectionToolbar, null) }))));
}
export default IssuesAnalyseDialog;
